<template>
    <div class="d-flex flex-1 h-100 overflow-auto delegation">
        <v-card class="report-container w-100  p-0" style="border-radius: 12px; margin-bottom: 24px">
            <v-toolbar class="shadow-none" style="flex: unset;" content-class="h-auto">
                <div class="custom-icon-wrapper">
                    <v-icon @click="backToAdminPage()">custom-icon left-arrow-icon</v-icon>
                </div>
                <v-toolbar-title class="size-16 dark-text">{{ $t("res_Title_ManageReference") }}</v-toolbar-title>
            </v-toolbar>

            <div class="border-top p-4 flex-1 overflow-auto">
                <div class="row justify-space-between m-0 gap-2">
                    <div class="p-0" style="width: 18%">
                        <v-label class="label_required mb-1">{{ $t("res_Label_Category") }}</v-label>
                        <div class="with-absolute-button">
                            <multi-select class="light-bg add-arrow w-100" v-model="selectedCategory" label="name" track-by="id"
                                open-direction="bottom" :options="applicationsOptions" :searchable="false" 
                                :internal-search="false" :clear-on-select="false" :close-on-select="true" :options-limit="300"
                                :max-height="1000" :show-no-results="false" :hide-selected="false" :multiple="false"
                                :placeholder="$t('res_Label_Select')">
                            </multi-select>
                        </div>
                    </div>
                    <div class="p-0" style="width: 23%">
                        <v-label class="label_required mb-1">{{ $t("res_Label_SelectCompany") }}</v-label>
                        <div class="with-absolute-button">
                            <multi-select class="light-bg add-arrow w-100" v-model="companyId" label="name" track-by="id"
                                open-direction="bottom" :options="company_items" :searchable="true" @input="onCompanyChange"
                                :internal-search="true" :clear-on-select="false" :close-on-select="true" :options-limit="300"
                                :max-height="1000" :show-no-results="false" :hide-selected="false" :multiple="false"
                                :placeholder="$t('res_Label_Select')">
                            </multi-select>
                        </div>
                    </div>

                    <div class="p-0" style="width: 23%">
                        <label class="label_required mb-1">{{ $t("res_Label_Structure") }}</label>
                        <StructureUserSelector class=" w-100" :showInternalUsers="false" :showExternalUsers="false"
                            :showInternalStructures="true" :showExternalStructures="false" :isMultiple="false"
                            :selectedStructureUser="structureId" :disableOtherInternalEntitiesAsExternal="true" :isSubscribedEntitiesEnable="this.constants.client_version_Id == 'DEG' && true"
                            @structureUserSelectChanged="structureUserSelectChanged"
                            :addressBook_header="$t('res_Label_SelectStructure')">
                        </StructureUserSelector>
                    </div>
                    <div class="p-0" style="width: 28%">
                        <label class="label_required mb-1">{{ $t("res_MenuItems_ChooseTemplate") }}</label>
                        <multi-select class="light-bg add-arrow w-100 SelectTemplateClass" v-model="templateId" label="text" track-by="id"
                            open-direction="bottom" :options="templates_items" :searchable="true" 
                            :internal-search="true" :clear-on-select="false" :close-on-select="true" :options-limit="300"
                            :max-height="1000" :show-no-results="false" :hide-selected="false" :multiple="false"
                            :placeholder="$t('res_Label_Select')">
                        </multi-select>
                    </div>
                </div>
                <v-row>
                    <div class="d-flex justify-space-between align-items-center ">
                        <v-checkbox class="m-0" v-model="byPdf" :label="byPdfLabel"></v-checkbox>
                        <div class="d-flex gap-2">
                            <v-btn @click="clear()" width="100px" color="mx-2 light-blue">{{ $t("res_ButtonText_Clear") }}</v-btn>
                            <v-btn @click="displayCategory()" width="100px" color="primary">{{ $t("res_ButtonText_Search") }}</v-btn>
                            <v-btn @click="addDialog = true" width="100px" color="mx-2 primary">{{ $t("res_ButtonText_Add") }}</v-btn>
                        </div>
                    </div>
                </v-row>
                <hr>
                <v-data-table :headers="headers" :items="displayedItems" item-key="id" disable-sort hide-default-footer
                    class="position-relative white flex-1 d-flex overflow-auto"  :items-per-page="displayedItems.length">
                    <template v-slot:item="row">
                        <tr>
                            <td>{{ applicationsOptions.find(x => x.id == row.item.categoryId)?.name }}</td>
                            <td>{{ company_items.find(x => x.id == row.item.companyId)?.name }}</td>
                            <td>{{ templates_items.find(x => x.id == row.item.templateId)?.name }}</td>
                            <td>{{ row.item.structureName }}</td>
                            <td>{{ row.item.type }}</td>
                            <td>{{ row.item.content }}</td>
                            <td>{{ row.item.order }}</td>
                            <td>{{ row.item.byPdf }}</td>
                            <td class="text-start">
                                <div class="onhover-display">
                                    <div class="custom-icon-wrapper">
                                        <v-icon small @click="dialogEdit(row.item)">custom-icon white-bg edit-icon</v-icon>
                                    </div>
                                    <div class="custom-icon-wrapper">
                                        <v-icon small @click="deleteCategory(row.item)">custom-icon white-bg delete-icon</v-icon>
                                    </div>
                                </div>
                            </td>
                        </tr>
                    </template>
                </v-data-table>
            </div>

            <v-dialog v-model="addDialog" max-width="800px">
                <v-card>
                    <v-card-title>{{ $t("res_ButtonText_Add") }}</v-card-title>
                    <v-card-text>
                        <v-row>
                            <v-col cols="6">
                                <v-label>{{ $t("res_Label_Category") }}* </v-label>
                                <multi-select class="light-bg add-arrow" v-model="addFormDialog.selectedCategory" label="name" track-by="id"
                                    open-direction="bottom" :options="applicationsOptions" :searchable="false" 
                                    :internal-search="false" :clear-on-select="false" :close-on-select="true" :options-limit="300"
                                    :max-height="600" :show-no-results="false" :hide-selected="false" :multiple="false"
                                    :placeholder="$t('res_Label_Select')">
                                </multi-select>
                            </v-col>
                            <v-col cols="6">
                                <v-label>{{ $t("res_Label_SelectCompany") }} </v-label>
                                <multi-select class="light-bg add-arrow" v-model="addFormDialog.companyId" label="name" track-by="id"
                                    open-direction="bottom" :options="company_items" :searchable="true" @input="onCompanyAddChange" 
                                    :internal-search="true" :clear-on-select="false" :close-on-select="true" :options-limit="300"
                                    :max-height="600" :show-no-results="false" :hide-selected="false" :multiple="false"
                                    :placeholder="$t('res_Label_Select')">
                                </multi-select>
                            </v-col>
                            <v-col cols="6">
                                <v-label>{{ $t("res_Label_Structure") }} </v-label>
                                <StructureUserSelector class=" w-100" :showInternalUsers="false" :showExternalUsers="false"
                                    :showInternalStructures="true" :showExternalStructures="false" :isMultiple="false"  
                                    :selectedStructureUser="addFormDialog.structureId" :disableOtherInternalEntitiesAsExternal="true"
                                    @structureUserSelectChanged="structureUserSelectChangedAdd"
                                    :addressBook_header="$t('res_Label_SelectStructure')">
                                </StructureUserSelector>
                            </v-col>
                            <v-col cols="6">
                                <v-label>{{ $t("res_MenuItems_ChooseTemplate") }} </v-label>
                                <multi-select class="light-bg add-arrow SelectTemplateClass" v-model="addFormDialog.templateId" label="text"
                                    track-by="id" open-direction="bottom" :options="templates_items" :searchable="true"
                                     :internal-search="true" :clear-on-select="false" :close-on-select="true"
                                    :options-limit="300" :max-height="1000" :show-no-results="false" :hide-selected="false"
                                    :multiple="false" :placeholder="$t('res_Label_Select')">
                                </multi-select>
                            </v-col>
                            <v-col cols="6">
                                <v-label>{{ $t("res_GridHeaders_Type") }}*</v-label>
                                <multi-select class="light-bg add-arrow" v-model="addFormDialog.type" :options="typeOption" label="name"
                                    track-by="id" 
                                    open-direction="bottom" :searchable="true" 
                                    :internal-search="true" :clear-on-select="false" :close-on-select="true"
                                    :options-limit="300" :max-height="1000" :show-no-results="false" :hide-selected="false"
                                    :multiple="false" :placeholder="$t('res_Label_Select')">
                                </multi-select>
                            </v-col>
                            <v-col cols="6">
                                <v-label>{{ $t("res_Label_Content") }}*</v-label>
                                <v-text-field v-model="addFormDialog.content" label="" solo></v-text-field>
                            </v-col>
                            <v-col cols="6">
                                <v-label>{{ $t("res_Label_Order") }}*</v-label>
                                <v-text-field v-model="addFormDialog.order" type="number" label="" solo></v-text-field>
                            </v-col>
                            <v-col cols="6">
                                <v-label>{{ $t("res_CheckBox_ByPdf") }}</v-label>
                                <v-checkbox class="m-0" v-model="addFormDialog.byPdf" solo></v-checkbox>
                            </v-col>
                        </v-row>
                    </v-card-text>
                    <v-card-actions class="gap-2 sticky-actions">
                        <v-spacer></v-spacer>
                        <v-btn class="light-blue" style="min-width: 100px !important" @click="closeDialog()">{{ $t("res_ButtonText_Close") }}</v-btn>
                        <v-btn class="primary" style="min-width: 100px !important" @click="addCategoryReference()">{{ $t("res_ButtonText_Add") }}</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>

            <v-dialog v-model="editDialog" max-width="800px">
                <v-card>
                    <v-card-title>{{ $t("res_ButtonText_Edit") }}</v-card-title>
                    <v-card-text>
                        <v-row>
                            <v-col cols="6">
                                <v-label>{{ $t("res_Label_Category") }} </v-label>
                                <multi-select class="light-bg add-arrow" v-model="editedItem.selectedCategory" label="name" track-by="id"
                                    open-direction="bottom" :options="applicationsOptions" :searchable="false" 
                                    :internal-search="true" :clear-on-select="false" :close-on-select="true" :options-limit="300"
                                    :max-height="600" :show-no-results="false" :hide-selected="false" :multiple="false"
                                    :placeholder="$t('res_Label_Select')">
                                </multi-select>
                            </v-col>
                            <v-col cols="6">
                                <v-label>{{ $t("res_Label_SelectCompany") }} </v-label>
                                <multi-select class="light-bg add-arrow" v-model="editedItem.companyId" label="name" track-by="id"
                                    open-direction="bottom" :options="company_items" :searchable="true" @input="onCompanyEditChange"
                                    :internal-search="true" :clear-on-select="false" :close-on-select="true" :options-limit="300"
                                    :max-height="600" :show-no-results="false" :hide-selected="false" :multiple="false"
                                    :placeholder="$t('res_Label_Select')">
                                </multi-select>
                            </v-col>
                            <v-col cols="6">
                                <v-label>{{ $t("res_Label_Structure") }} </v-label>
                                <StructureUserSelector class=" w-100" v-model="editedItem.structureId" :showInternalUsers="false" :showExternalUsers="false"
                                    :showInternalStructures="true" :showExternalStructures="false" :isMultiple="false"  
                                    :selectedStructureUser="editedItem.structureId" :disableOtherInternalEntitiesAsExternal="true"
                                    @structureUserSelectChanged="structureUserSelectChangedEdit"
                                    :addressBook_header="$t('res_Label_SelectStructure')">
                                </StructureUserSelector>
                            </v-col>
                            <v-col cols="6">
                                <v-label>{{ $t("res_MenuItems_ChooseTemplate") }} </v-label>
                                <multi-select class="light-bg add-arrow SelectTemplateClass" v-model="editedItem.templateId" label="text" track-by="id"
                                    open-direction="bottom" :options="templates_items" :searchable="false" 
                                    :internal-search="false" :clear-on-select="false" :close-on-select="true" :options-limit="300"
                                    :max-height="1000" :show-no-results="false" :hide-selected="false" :multiple="false"
                                    :placeholder="$t('res_Label_Select')">
                                </multi-select>
                            </v-col>
                            <v-col cols="6"> 
                                <v-label>{{ $t("res_GridHeaders_Type") }}*</v-label>
                                <multi-select class="light-bg add-arrow" v-model="editedItem.type" :options="typeOption" 
                                    label="name" track-by="id" 
                                    open-direction="bottom" :searchable="true" 
                                    :internal-search="true" :clear-on-select="false" :close-on-select="true"
                                    :options-limit="300" :max-height="1000" :show-no-results="false" :hide-selected="false"
                                    :multiple="false" :placeholder="$t('res_Label_Select')">
                                </multi-select>                         </v-col>
                            <v-col cols="6">
                                <v-label>{{ $t("res_Label_Content") }}*</v-label>
                                <v-text-field v-model="editedItem.content" label="" solo></v-text-field>
                            </v-col>
                            <v-col cols="6">
                                <v-label>{{ $t("res_Label_Order") }}*</v-label>
                                <v-text-field v-model="editedItem.order" type="number" label="" solo></v-text-field>
                            </v-col>
                            <v-col cols="6">
                                <v-label>{{ $t("res_CheckBox_ByPdf") }}</v-label>
                                <v-checkbox class="m-0" v-model="editedItem.byPdf" solo></v-checkbox>
                            </v-col>
                        </v-row>
                    </v-card-text>
                    <v-card-actions class="gap-2 sticky-actions">
                        <v-spacer></v-spacer>
                        <v-btn class="light-blue" style="min-width: 100px !important" @click="editDialog = false">{{ $t("res_ButtonText_Close") }}</v-btn>
                        <v-btn class="primary" style="min-width: 100px !important" @click="UpdateCategory()">{{ $t("res_ButtonText_Update") }}</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </v-card>
    </div> 
</template>

<style>
.SelectTemplateClass .multiselect__content-wrapper{ 
    position: absolute;  
    top: -10px;
    overflow-x: hidden;
}

</style>
<script>
    import axios from "axios";
    import constants from '@/assets/js/constants'
    import router from "../../router/index.js";
    import MultiSelect from 'vue-multiselect';
    import StructureUserSelector from '@/components/StructureUserSelector.vue';

    export default {
        components: { MultiSelect, StructureUserSelector },
        data() {
            return {
                language: '',
                headers: [
                    { text: this.$t("res_GridHeader_Category"), value: "categoryId", align: "start", width: "10%" },
                    { text: this.$t("res_GridHeader_Company"), value: "companyId", align: "start", width: "10%" },
                    { text: this.$t("res_GridHeader_Template"), value: "templateId", align: "start", width: "20%"},
                    { text: this.$t("res_GridHeaders_Structure"), value: "structureId", align: "start", width: "10%" },
                    { text: this.$t("res_GridHeaders_Type"), value: "type", align: "start", width: "10%" },
                    { text: this.$t("res_GridHeader_Content"), value: "content", align: "start", width: "10%" },
                    { text: this.$t("res_GridHeaders_Order"), value: "order", align: "start", width: "10%" },
                    { text: this.$t("res_GridHeader_ByPdf"), value: "bypdf", align: "start", width: "10%" },
                    { text: this.$t("res_GridHeaders_Actions"), value: "Action", align: "start", width: "10%" },
                ],
                typeOption: [{ id: 1, name: "String" }, { id: 2, name: "Year" }, { id: 3, name: "Counter" }, { id: 4, name: "Code" }, { id: 5, name: "Format" }],
                selectedCategory: null,
                displayedItems: [],
                applicationsOptions: [],
                editDialog: false,
                addDialog: false,
                editedItem: {
                    id: 0,
                    type: {},
                    content: "",
                    order: 0,
                    byPdf: false,
                    companyId: {},
                    structureId: null,
                    templateId: {},
                    selectedCategory: null
                },
                addFormDialog: {
                    id: 0,
                    type: "",
                    content: "",
                    order: 0,
                    categoryId: 0,
                    structureId: null,
                    companyId: {},
                    templateId: {},
                    byPdf: false,
                    selectedCategory: null
                },
                company_items: [],
                templates_items: [],
                structureId: null,
                companyId: null,
                templateId: null,
                byPdf: false,
                byPdfLabel: '',
                constants:constants
            };
        },
        methods: {
            backToAdminPage() {
                router.push({ name: "admin" });
            },
            structureUserSelectChanged(selectedItem) {
                if (selectedItem) {
                    this.companyId = null;
                    this.toUser = selectedItem;
                    this.getAllTemplates(this.selectedCategory == null ? 0 : this.selectedCategory.id, selectedItem == null ? 0 : selectedItem.id);
                } else {
                    this.toUser = null
                    this.getAllTemplates(this.selectedCategory == null ? 0 : this.selectedCategory.id, 0);
                }
            },
            structureUserSelectChangedAdd(selectedItem) {
                if (selectedItem) {
                    this.addFormDialog.companyId = null
                    this.addFormDialog.structureId = selectedItem;
                    this.getAllTemplates(this.addFormDialog.selectedCategory == null ? 0 : this.addFormDialog.selectedCategory.id, selectedItem == null ? 0 : selectedItem.id);
                } else {
                    this.addFormDialog.structureId = null
                    this.getAllTemplates(this.addFormDialog.selectedCategory == null ? 0 : this.addFormDialog.selectedCategory.id, 0);
                }
            },
            structureUserSelectChangedEdit(selectedItem)
            {
                if (selectedItem) {
                    this.editedItem.companyId = null
                    this.editedItem.structureId = selectedItem;
                    this.getAllTemplates(this.editedItem.selectedCategory == null ? 0 : this.editedItem.selectedCategory.id, selectedItem == null ? 0 : selectedItem.id);
                } else {
                    this.editedItem.structureId = null
                    this.getAllTemplates(this.editedItem.selectedCategory == null ? 0 : this.editedItem.selectedCategory.id, 0);
                }
            },
            closeDialog() {
                this.addDialog = false;
                this.resetDataForm();
            },
            dialogEdit(item) {
                const type = this.typeOption.find(x => x.name == item.type);
                const template = this.templates_items.find(x => x.id == item.templateId);
                this.editedItem = {
                    id: item.id,    
                    type: type,
                    content: item.content,
                    byPdf: item.byPdf,
                    order: item.order,
                    templateId: template,
                    structureId: {id: item.structureId, name: item.structureName, isUser: false },
                    companyId: this.company_items.find(x => x.id == item.companyId),
                    selectedCategory: this.applicationsOptions.find(x => x.id == item.categoryId)
                }
                this.editDialog = true;
            },
            getCompaniesForUser() {
                window.showLoading()
                axios.get(constants.baseApiUrl + "Admin/GetCompaniesForUser")
                    .then((res) => {
                        this.company_items = res.data;
                        window.hideLoading();
                    })
                    .catch((err) => console.warn(err))
                    .finally(() => window.hideLoading());
            },
            getAllTemplates(categoryId = 0, companyId = 0) {
                window.showLoading()
                axios.get(constants.baseApiUrl + "Admin/GetAllFilteredTemplates?categoryId=" + categoryId + "&structureId=" + companyId)
                    .then((res) => {
                        this.templates_items = res.data;
                        window.hideLoading();
                    })
                    .catch((err) => console.warn(err))
                    .finally(() => window.hideLoading());
            },
            fetchData() {
                window.showLoading()
                axios.get(constants.baseApiUrl + "Admin/GetAllCategory?isDecreeEnabled="+constants.isDecreeEnabled+"&isCircularEnabled="+constants.isCircularEnabled)
                    .then(response => 
                    {
                        const responseData = response.data;
                        if(this.language == 'en') {
                            for (let i = 0; i < responseData.length; i++) {
                                const category = { id: responseData[i].id,  name: responseData[i].name };
                                this.applicationsOptions.push(category);
                            }
                        } else {
                            for (let i = 0; i < responseData.length; i++) {
                                const category = { id: responseData[i].id,  name: responseData[i].nameAr };
                                this.applicationsOptions.push(category);
                            }
                        }
                        window.hideLoading();

                    }) 
                    .catch((err) => console.warn(err))
                    .finally(() => window.hideLoading());   
            },
            GetReferenceCategories(){
             axios.get(`${constants.baseApiUrl}Admin/GetReferenceCategories`)
             .then((res)=>{
               this.displayedItems = res.data.result;
             }).catch((error)=>{
                console.warn(error);
             });
            },
            displayCategory() 
            {
                window.showLoading()
                const requestData = {
                    CategoryId: this.selectedCategory == null ? null : this.selectedCategory.id,
                    CompanyId: this.companyId == null ? null : this.companyId.id,
                    StructureId: this.structureId == null ? null : this.structureId.id,
                    TemplateId: this.templateId == null ? null : this.templateId.id,
                    ByPdf: this.byPdf
                };
                axios.post(
                    constants.baseApiUrl + 'Admin/GetFilteredReferenceCategories', requestData, { headers: constants.headers }
                )
                .then((res) => 
                { 
                    this.displayedItems = res.data;
                    window.hideLoading();
                })
                .catch((error) => console.error("Error fetching data:", error))
                .finally(() => window.hideLoading());
            },
            resetDataForm() {
                this.addFormDialog.type = null;
                this.addFormDialog.order = 0;
                this.addFormDialog.content = null;
                this.addFormDialog.companyId = null;
                this.addFormDialog.byPdf = false;
                this.addFormDialog.templateId = null;
                this.addFormDialog.structureId = null;
                this.addFormDialog.selectedCategory = null;
            },
            clear() {
                this.selectedCategory = null;
                this.structureId = null;
                this.companyId = null;
                this.templateId = null;
                this.byPdf = false;
                this.GetReferenceCategories();
            },
            addCategoryReference() {
                if (this.addFormDialog.selectedCategory == null || this.addFormDialog.type == '' || this.addFormDialog.order == null || this.addFormDialog.content == '') {
                    return window.showAlert('res_Msgs_FillRequired', 'warning')
                }

                var addNewCategory = {
                    CategoryId: this.addFormDialog.selectedCategory.id,
                    Type: this.addFormDialog.type.name,
                    Order: this.addFormDialog.order,
                    Content: this.addFormDialog.content,
                    CompanyId: this.addFormDialog.companyId == null ? null : this.addFormDialog.companyId.id,
                    TemplateId: this.addFormDialog.templateId == null ? null : this.addFormDialog.templateId.id,
                    StructureId: this.addFormDialog.structureId == null || this.addFormDialog.structureId.id == 0 ? null : this.addFormDialog.structureId.id,
                    ByPdf: this.addFormDialog.byPdf
                };

                window.showLoading()
                axios.post(constants.baseApiUrl + "Admin/AddNewreferenceNumber", addNewCategory)
                    .then((res) => 
                    {
                        if (res == undefined || res.data == null)
                            window.showAlert("res_Msgs_ErrorOccured", "error");
                        else 
                        {
                            this.addDialog = false
                            window.showAlert("res_Msgs_AddFormatCounter", "success")
                            this.resetDataForm()
                            this.displayCategory();
                        }
                        window.hideLoading();
                    })
                    .catch((err) => {
                        this.handleError(err);
                        window.hideLoading();
                    })
                    .finally(() => window.hideLoading());
            },
            deleteCategory(item) {
                window.showInformation(
                    "Confirmation",
                    "res_Msgs_CategoryReferenceDeleteConfirmation",
                    () => {
                    axios.delete(constants.baseApiUrl + "Admin/DeleteCategoryNumber/" + item.id)
                        .then((res) => {
                            window.showAlert("res_Msgs_FormatCountDeleted", "success");
                            this.displayCategory();
                        })
                        .catch((err) => console.log(err));
                    },
                    () => { }
                );
            },
            UpdateCategory() {
                if (this.editedItem.selectedCategory == null || this.editedItem.type == null || this.editedItem.content == '' || this.editedItem.order == null  || this.editedItem.order == "") {
                    return window.showAlert('res_Msgs_FillRequired', 'warning')
                }

                var editReference = { 
                    Type: this.editedItem.type.name, 
                    Order: this.editedItem.order, 
                    Content: this.editedItem.content,
                    CompanyId: this.editedItem.companyId == null ? null : this.editedItem.companyId.id,
                    TemplateId: this.editedItem.templateId == null ? null : this.editedItem.templateId.id,
                    ByPdf: this.editedItem.byPdf,
                    CategoryId: this.editedItem.selectedCategory.id,
                    StructureId:  this.editedItem.structureId?.id || null
                };
                
                axios.post(constants.baseApiUrl + "Admin/UpdateCategoryNumber/" + this.editedItem.id, editReference)
                    .then((res) => 
                    {
                        if (res == undefined || res.data == null) 
                        {
                            window.showAlert("res_Msgs_ErrorOccured", "error");
                        } 
                        else 
                        {
                            window.showAlert("res_Msgs_FormatCountUpdated", "success");
                            this.editDialog = false;
                            this.displayCategory();
                        }
                        window.hideLoading();
                    })
                    .catch((err) => {
                        this.handleError(err);
                        window.hideLoading();
                    })
                    .finally(() => window.hideLoading());
            },
            onCompanyChange(value)
            {
                this.displayedItems = [];
                this.structureId = null;
                this.getAllTemplates(this.selectedCategory == null ? 0 : this.selectedCategory.id, value == null ? 0 : value.id);
            },
            onCompanyAddChange(value)
            {
                this.addFormDialog.structureId = null;
                this.getAllTemplates(this.addFormDialog.selectedCategory == null ? 0 : this.addFormDialog.selectedCategory.id, value == null ? 0 : value.id);
            },
            onCompanyEditChange(value)
            {
                this.editedItem.structureId = null;
                this.getAllTemplates(this.editedItem.selectedCategory == null ? 0 : this.editedItem.selectedCategory.id, value == null ? 0 : value.id);
            },
        },
        mounted() {
            this.displayCategory();
            this.getCompaniesForUser();
            this.getAllTemplates();
            this.fetchData();
            this.displayCategory(); 
            this.language = localStorage.getItem('lang');
            this.byPdfLabel = window.translate("res_CheckBox_ByPdf");
        },
        watch: {
            selectedCategory: function (val) {
                var companyOrStructure = this.companyId == null ? this.toUser == null ? 0 : 
                    this.toUser.id : this.companyId.id;
                this.getAllTemplates(val == null ? 0 : val.id, companyOrStructure);
            },
            'addFormDialog.selectedCategory': function (val) {
                var companyOrStructure = this.addFormDialog.companyId == null ? (this.addFormDialog.structureId?.id ?? 0) : this.addFormDialog.companyId.id;
                this.getAllTemplates(val == null ? 0 : val.id, companyOrStructure);
            },
            'editedItem.selectedCategory': function (val) {
                var companyOrStructure = this.editedItem.companyId == null ? (this.editedItem.structureId?.id ?? 0) : this.editedItem.companyId.id;
                this.getAllTemplates(val == null ? 0 : val.id, companyOrStructure);
            },
        }
    };
</script>